import { useMyPhotoUrl, useMyProfile } from '@/lib/profile';

/**
 * 프로필 동그라미 — 사진이 있으면 얼굴, 없으면 <b>이름 첫 글자</b>.
 *
 * <p>회색 사람 아이콘을 두지 않는다. 그것은 「사진이 빠진 칸」으로 읽혀서 사람이 자기 화면을
 * 고장으로 본다 — 없는 것의 자리를 세우지 않는다는 규율이 이 자리에도 같다.
 *
 * <p>사진은 `useMyPhotoUrl` 이 react-query 로 한 번만 받아 공유한다. 머리줄·관문·마이페이지
 * 셋에서 동시에 서므로 컴포넌트마다 받으면 같은 바이트를 세 번 가져온다.
 */
export function Avatar({ size = 48, name }: { size?: number; name?: string }) {
  const profile = useMyProfile();
  const url = useMyPhotoUrl(profile.data?.hasPhoto ?? false);

  // 이름은 세션이 먼저 들고 있다 — 프로필이 오기 전에도 글자가 서야 동그라미가 비지 않는다.
  const label = (name ?? profile.data?.name ?? '').slice(0, 1);

  return (
    <span
      aria-hidden
      className="flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold"
      style={{
        width: size,
        height: size,
        // 글자 크기는 지름에 맞춘다 — 머리줄(28px)과 관문(48px)이 같은 컴포넌트를 쓴다.
        fontSize: Math.round(size * 0.42),
        background: 'var(--accent-bg)',
        color: 'var(--accent)',
      }}
    >
      {url === null ? label : <img src={url} alt="" className="h-full w-full object-cover" />}
    </span>
  );
}
